import ReactJoyride, {
  CallBackProps,
  STATUS,
  Step,
  Styles,
} from 'react-joyride';
import { useTranslation } from 'react-i18next';

const customStyles: Partial<Styles> = {
  tooltip: {
    borderRadius: '16px',
  },
  tooltipContainer: {
    fontFamily: 'Isidora Sans, sans-serif',
    height: 'fit-content',
    lineHeight: 1.2,
    color: '#000',
    opacity: 1,
  },
  buttonNext: {
    backgroundColor: '#10A4B1',
    outline: 'none',
    fontFamily: 'Isidora Sans, sans-serif',
    padding: '8px 20px 7px',
    borderRadius: '4px',
    fontWeight: 500,
  },
  buttonBack: {
    backgroundColor: '#10A4B1',
    outline: 'none',
    fontFamily: 'Isidora Sans, sans-serif',
    padding: '8px 20px 7px',
    borderRadius: '4px',
    fontWeight: 500,
    color: '#fff',
  },
  buttonSkip: {
    color: '#10A4B1',
    fontFamily: 'Isidora Sans, sans-serif',
    fontWeight: 500,
  },
};

interface AppWalkthroughProps {
  run: boolean;
  steps: Array<Step>;
  onComplete?: () => void;
}

export default function AppWalkthrough({
  run,
  steps,
  onComplete,
}: AppWalkthroughProps) {
  const { t } = useTranslation();

  const handleCallback = (data: CallBackProps) => {
    const { status } = data;

    if (status === STATUS.FINISHED) {
      onComplete?.();
    } else if (status === STATUS.SKIPPED) {
      onComplete?.();
    }
  };

  return (
    <ReactJoyride
      continuous
      callback={handleCallback}
      run={run}
      steps={steps}
      hideCloseButton
      scrollToFirstStep
      showSkipButton
      showProgress={false}
      styles={customStyles}
      disableOverlayClose={true}
      locale={{
        last: t('finish'),
        next: t('next'),
        back: t('back'),
        skip: t('skip'),
        close: t('close'),
      }}
    />
  );
}
